import React from "react"
import { Col, Row, Icon as AIcon } from "antd"
import { MoreIcon, CheckedIcon } from "../core/icons"
import Card from "../core/Card"
import "./FAQ.css"

const FAQ = props => (
  <Card className="FAQ">
    <h1>Frequently Asked Questions</h1>
    <h4>Can I use Everlance without having to upgrade to Premium?</h4>
    <p>
      If you don’t upgrade you can continue using Everlance on our free plan
      (with limited Automatic Trip Detection), after which you will no longer
      have access to Premium features. You will ALWAYS have access to your data
      and be able to manually record trips, receipts and transactions.
    </p>
    <h4>Can I cancel Everlance Premium at anytime?</h4>
    <p>
      Since we offer a steep discount for prepaying for the Annual plan, all
      sales of the Everlance Premium Annual Plan are final. You can set the
      subscription to cancel for the next billing period at anytime. If you are
      still unsure after the Premium Trial, we recommend subscribing to the
      Monthly Plan until you are sure Everlance Premium is a service for you.
    </p>
    <h4>Is there an Everlance Premium trial?</h4>
    <p>
      Yes, every new user starts on the Everlance Premium trial. This enables
      you to evaluate if our Premium service is for you. If you choose not to
      upgrade to Everlance Premium after the trial has ended, you will then
      start on our free plan, where you have access to your data (including
      exports) and be able to manually record trips, receipts and transactions.
    </p>
    <h4>Can I use Everlance Premium for my company or small business?</h4>
    <p>
      Yes, Everlance was not only built for freelancers and independent
      contractors but also for small and large business alike. There are many
      companies that use Everlance for expense tracking, reimbursements and
      employee tax purposes. If interested in Everlance for your company, please
      contact us at sales@everlance.com.
    </p>
  </Card>
)

export default FAQ



// WEBPACK FOOTER //
// ./src/subscriptions/FAQ.jsx